/* ====================================================
   KD vB · Lenis 4 effects (1 + 2 + 5 + 6)
   1) Lenis baseline smooth scroll
   2) Hero product parallax + scale-out
   5) Hero title word-by-word reveal (runtime DOM wrap)
   6) Marquee speed follows scroll velocity
   ==================================================== */
(function () {
  'use strict';

  // ── Guards ────────────────────────────────────────
  // Don't run inside Shopify Theme Customizer (would break editing scroll)
  if (window.Shopify && window.Shopify.designMode) return;
  // Honor user's reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ════════════ Word reveal (runs IMMEDIATELY — independent of Lenis) ════════════ */
  function doWordReveal() {
    var heroSec = document.querySelector('.kdvb-hero');
    var heroTitle = heroSec ? heroSec.querySelector('.title') : null;
    if (!heroTitle || heroTitle.dataset.kdLenisWrapped) return;

    var marker = '__KDBR__';
    var raw = heroTitle.innerHTML.trim()
      .replace(/<br\s*\/?>/gi, marker)
      .replace(/<[^>]+>/g, '');
    var lines = raw.split(marker);
    var html = lines.map(function (line) {
      var words = line.trim().split(/\s+/);
      return words.map(function (w) {
        if (/^DOPA\b/i.test(w)) {
          // DOPA: ambient blob halo (Voice Orb pattern) behind the text — 4 mix-blend pieces inside
          return '<span class="kd-lenis-word kd-lenis-word--glow">' +
                 '<span class="kd-halo" aria-hidden="true">' +
                   '<span class="kd-halo-piece kd-halo-piece-1"></span>' +
                   '<span class="kd-halo-piece kd-halo-piece-2"></span>' +
                   '<span class="kd-halo-piece kd-halo-piece-3"></span>' +
                   '<span class="kd-halo-piece kd-halo-piece-4"></span>' +
                 '</span>' + w + '</span>';
        }
        return '<span class="kd-lenis-word">' + w + '</span>';
      }).join(' ');
    }).join('<br>');
    heroTitle.innerHTML = html;
    heroTitle.dataset.kdLenisWrapped = '1';

    // Stagger reveal IMMEDIATELY — no window.load wait
    var wordEls = heroTitle.querySelectorAll('.kd-lenis-word');
    wordEls.forEach(function (w, i) {
      setTimeout(function () { w.classList.add('show'); }, 50 + i * 80);
    });
  }

  function init() {
    // 1. Word reveal — runs first, independent of Lenis
    doWordReveal();

    if (typeof Lenis !== 'function') {
      console.warn('[kd-lenis] Lenis not loaded — word reveal still ran');
      return;
    }

    /* ════════════ 1) Lenis baseline ════════════ */
    var lenis = new Lenis({
      duration: 0.95,                // tighter than default 1.2s
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      smoothTouch: false,            // mobile keeps native momentum
      touchMultiplier: 2
    });
    window.__kdLenis = lenis;

    function getHeaderSafeOffset() {
      var wrapper = document.querySelector('.m-header__wrapper');
      if (!wrapper) return 0;
      var height = Math.ceil(wrapper.getBoundingClientRect().height) || 0;
      if (height < 20 || height > 180) return 0;
      return height + 12;
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 767px), (hover: none)').matches;
    }

    function getAnchorScrollY(target) {
      var safeOffset = getHeaderSafeOffset();
      var wrapper = document.querySelector('.m-header__wrapper');
      var wrapperFixed = wrapper && getComputedStyle(wrapper).position === 'fixed';
      var flowCompensation = isMobileViewport() && !wrapperFixed ? safeOffset : 0;
      return target.getBoundingClientRect().top + window.pageYOffset - safeOffset - flowCompensation;
    }

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    /* ════════════ 2) Hero parallax + scale-out ════════════ */
    var heroSec = document.querySelector('.kdvb-hero');
    // Target the .product wrapper so all 5 cans + glow transform together
    var heroGroup = heroSec ? heroSec.querySelector('.product') : null;
    // Title gets the same parallax recipe — preserves its static skewX(-4deg)
    var heroTitleEl = heroSec ? heroSec.querySelector('.title') : null;
    if (heroGroup) {
      heroGroup.style.willChange = 'transform, opacity';
    }
    if (heroTitleEl) {
      heroTitleEl.style.willChange = 'transform, opacity';
    }
    // All non-hero H2s pop in once when entering the viewport, then stay visible.
    var sectionH2s = Array.prototype.slice.call(document.querySelectorAll('.kdvb-h2')).filter(function (h2) {
      var sec = h2.closest('section');
      return !sec || !sec.classList.contains('kdvb-hero');
    });
    if (sectionH2s.length && 'IntersectionObserver' in window) {
      var ioH2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            ioH2.unobserve(e.target);
          }
        });
      }, { threshold: 0.01, rootMargin: '0px 0px -15% 0px' });
      sectionH2s.forEach(function (h2) { ioH2.observe(h2); });
    } else {
      // No IO support (very old browsers): just show all
      sectionH2s.forEach(function (h2) { h2.classList.add('in'); });
    }

    /* (5) hero word reveal already triggered above by doWordReveal() — no duplicate */

    /* ════════════ 6) Marquee speed follows scroll velocity ════════════ */
    // Minimog scrolling-promotion: animation-duration is `--duration` on .m-promotion--animated
    var promos = document.querySelectorAll('.m-promotion--animated');
    var promoBaseDur = [];
    promos.forEach(function (p, i) {
      var d = parseFloat(getComputedStyle(p).animationDuration) || 38;
      promoBaseDur[i] = d;
      p.style.setProperty('--duration', d + 's');
    });

    /* ════════════ Combined scroll handler ════════════ */
    lenis.on('scroll', function (e) {
      var scroll = e.scroll || 0;
      var velocity = Math.abs(e.velocity || 0);

      // ── 2) Hero parallax: drama dial — starts at 20% scroll, full effect at 80%
      // scale 1.05 (slight emphasis) -> 0.45 (real shrink)
      // translateY 0 -> -180px
      // opacity 1 -> 0.2
      if (heroSec && heroGroup) {
        var heroH = heroSec.offsetHeight;
        var p = Math.max(0, Math.min(1, (scroll - heroH * 0.20) / (heroH * 0.60)));
        var scale = 1.05 - p * 0.60;          // 1.05 -> 0.45
        var ty    = -180 * p;
        heroGroup.style.transform =
          'translateY(' + ty.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
        heroGroup.style.opacity = (1 - p * 0.8).toFixed(2);

        // Title — same parallax curve, but transform must keep skewX(-4deg).
        // Origin is left-center (set in CSS), so scale shrinks from the left edge.
        if (heroTitleEl) {
          heroTitleEl.style.transform =
            'translateY(' + ty.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ') skewX(-4deg)';
          heroTitleEl.style.opacity = (1 - p * 0.8).toFixed(2);
        }
      }


      // ── 6) Marquee: map velocity 0..150 -> base..8s (ease-out feel)
      promos.forEach(function (p, i) {
        var base = promoBaseDur[i] || 38;
        var target = Math.max(8, base - Math.min(150, velocity) * (base / 200));
        p.style.setProperty('--duration', target.toFixed(2) + 's');
      });
    });

    /* ════════════ Soft section snap ════════════
       Listens to native wheel/touchend; 800ms after the last input (lenis
       inertia has settled), if a vB section top is within 350px of the viewport
       top, glides to it. */
    var snapping = false;
    var snapTimer = null;
    var snapTargets = Array.prototype.slice.call(document.querySelectorAll('section.kdvb, .kdvb-hero, .kdvb-compare, .kdvb-faq, .kdvb-personas, .kdvb-howto, .kdvb-why, .kdvb-testimonials'))
      .filter(function (el, i, arr) { return arr.indexOf(el) === i; });
    function trySnap() {
      if (snapping) return;
      var nearest = null, dist = Infinity;
      snapTargets.forEach(function (s) {
        var t = s.getBoundingClientRect().top;
        var d = Math.abs(t);
        if (d < dist) { dist = d; nearest = s; }
      });
      var snapThreshold = isMobileViewport() ? 60 : 350;
      if (nearest && dist > 4 && dist < snapThreshold) {
        snapping = true;
        lenis.scrollTo(nearest, {
          offset: -getHeaderSafeOffset(),
          duration: 0.6,
          onComplete: function () {
            setTimeout(function () { snapping = false; }, 300);
          }
        });
      }
    }
    function onScrollInput() {
      if (snapping) return;
      clearTimeout(snapTimer);
      snapTimer = setTimeout(trySnap, 800);
    }
    window.addEventListener('wheel',     onScrollInput, { passive: true });
    window.addEventListener('touchend',  onScrollInput, { passive: true });
    window.addEventListener('keydown', function (e) {
      // Page Up/Down/Home/End/Arrow keys also count
      if ([32,33,34,35,36,38,40].indexOf(e.keyCode) >= 0) onScrollInput();
    }, { passive: true });

    // Anchor link smooth-scroll integration: route href="#x" through Lenis
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      ev.preventDefault();
      lenis.scrollTo(getAnchorScrollY(target), { duration: 1.2 });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
